type Props = {
  firstName: string
  lastName: string
}

export const getFullName = ({ firstName, lastName }: Props): string => {
  return `${lastName} ${firstName}`
}
